/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

// CSS
import '../../styles/ExpertiseContentCard.scss';
import { Divider } from '@adobe/react-spectrum';
import { formatNumber } from '../../util/util';

const ExpertiseContentCard = ({
  global,
  header,
  contentArray,
  contentObject,
  cardWidth,
  count,
  tabSection,
}) => {
  // Helper functions
  const cardWidthClass = () => {
    switch (cardWidth) {
      case '1':
        return 'card-width-1';
      case '3':
        return 'card-width-3';
      default:
        return 'card-width-2';
    }
  };

  const renderContent = () => {
    if (tabSection === 'specializations') {
      return contentArray.map((content) => (
        <div className="contentBox">{content}</div>
      ));
    }
    if (tabSection === 'deployment') {
      return Object.keys(contentObject).map((content) => (
        <div className="contentBox">{`${content}: ${formatNumber(contentObject[content])}`}</div>
      ));
    }
    return null;
  };

  return (
    <div className={`exp-content-card ${cardWidthClass()}`}>
      <div className="header">
        <h1>{header}</h1>
        {global ? <div className="globalBadge">Global</div> : count && <div className="countBadge">{tabSection === 'deployment' ? `Total: ${formatNumber(count)}` : formatNumber(count)}</div>}
      </div>
      {((contentArray && contentArray.length > 0) || (contentObject && Object.keys(contentObject).length > 0))
      && (
      <div>
        <Divider size="S" marginTop={10} marginBottom={10} UNSAFE_style={{ color: '#eaeaea' }} />

        <div className="contentSection">
          {renderContent()}
        </div>
      </div>
      )}
    </div>
  );
};

ExpertiseContentCard.propTypes = {
  global: PropTypes.bool,
  header: PropTypes.string,
  contentArray: PropTypes.arrayOf(PropTypes.string),
  contentObject: PropTypes.object,
  cardWidth: PropTypes.string,
  count: PropTypes.string,
  tabSection: PropTypes.string,
};

ExpertiseContentCard.defaultProps = {
  global: false,
  header: '',
  contentArray: [],
  contentObject: {},
  cardWidth: '1',
  count: '',
  tabSection: '',
};

export default ExpertiseContentCard;
